export default __webpack_public_path__ + "static/media/rep_dem_du_congo.21e8e932.svg";